import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import profilePicture from "../assets/dp.jpg";
import { RiMenu2Fill } from "react-icons/ri";
import ButtonCompo from "./ButtonCompo";
import { Link, useNavigate } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { GrDocumentTime } from "react-icons/gr";
import { FaRegCalendarTimes } from "react-icons/fa";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";
import PopOverBox from "./PopOverBox";
import { IoIosLogOut } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { SERVER_URL } from "../constant";
import { IoMdNotificationsOutline } from "react-icons/io";
import { GrUserAdmin } from "react-icons/gr";
import { LuUsers } from "react-icons/lu";
import { IoWalletOutline } from "react-icons/io5";
import { LiaUserEditSolid } from "react-icons/lia";
import { RiUserSettingsLine } from "react-icons/ri";
import { Badge, CircularProgress, LinearProgress } from "@mui/material";
import axios from "axios";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { GoGoal } from "react-icons/go";
import { IoDocumentTextOutline } from "react-icons/io5";
import { BsTicketPerforated } from "react-icons/bs";
import { IoMdTime } from "react-icons/io";
import { IoDocumentsOutline } from "react-icons/io5";
import { BsFiletypeDoc } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { GrUserSettings } from "react-icons/gr";
import { employeeLogout } from "../store/employeeAuth.slice";
import { IoPersonAddOutline } from "react-icons/io5";
import { FaRegCalendarPlus } from "react-icons/fa";
import { setAdminRoleData } from "../store/adminRole.slice";

function Header() {
  const [navOpen, setNavOpen] = useState(false);
  const isSuperadmin = useSelector(
    (state) => state.superadmin?.isSuperadminAuthenticated
  );
  const superadminData = useSelector(
    (state) => state.superadmin?.superadminData
  );
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [unopenedNotifications, setUnopenedNotofications] = useState(0);
  const reduxReload = useSelector((state) => state.reload?.reload);
  const [loading, setLoading] = useState(false);
  const [haveTeamMembers, setHaveTeamMembers] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // check whether any team member has some team members or not
  async function getTeamMembers() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/team/members`,
        method: "get",
        withCredentials: true,
      });
      const rawData = res.data?.data?.team;
      if (rawData?.length > 0) {
        setHaveTeamMembers(true);
      } else {
        setHaveTeamMembers(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // logout
  async function empLogout() {
    try {
      console.log("Hi");
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/logout`,
        method: "get",
        withCredentials: true,
      });
      console.log("Hi");
      dispatch(employeeLogout({ status: false }));
      navigate("/");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getTeamMembers();
  }, []);

  const employeeNavData = [
    {
      header: "Dashboard",
      link: "/employee/dashboard",
      icon: <RxDashboard />,
    },
    {
      header: "Attendance",
      link: "/employee/attendance",
      icon: <GrDocumentTime />,
    },
    {
      header: "Leaves & Holidays",
      link: "/employee/leave",
      icon: <FaRegCalendarTimes />,
    },
    {
      header: "Salary & Payslip",
      link: "/employee/salary",
      icon: <FaRegMoneyBillAlt />,
    },
    {
      header: "My Documents",
      link: "/employee/my-documents",
      icon: <IoDocumentAttachOutline />,
    },
    {
      header: "HR Policies",
      link: "/employee/hr/policies",
      icon: <IoDocumentAttachOutline />,
    },
    {
      header: "Tickets",
      link: "/employee/tickets",
      icon: <BsTicketPerforated />,
    },
    {
      header: "My Profile",
      link: "/my-profile",
      icon: <AiOutlineUser />,
    },
  ];

  const superadminNavData = [
    {
      header: "Dashboard",
      link: "/superadmin/dashboard",
      icon: <RxDashboard />,
    },
    {
      header: "Add Admin",
      link: "/superadmin/admins/add",
      icon: <GrUserAdmin />,
    },
    {
      header: "Employees",
      link: "/superadmin/employees",
      icon: <LuUsers />,
    },
    {
      header: "Onboard Employee",
      link: "/superadmin/employees/onboarding",
      icon: <LuUsers />,
    },
    {
      header: "Reset Password",
      link: "/superadmin/reset/password",
      icon: <GrUserSettings />,
    },
  ];

  const popOverData = [
    <ButtonCompo
      sx={{ fontSize: "13.5px" }}
      href="/my-profile"
      className="!flex !gap-2 !items-center"
    >
      <AiOutlineUser /> My Profile
    </ButtonCompo>,
    <ButtonCompo
      sx={{ fontSize: "13.5px" }}
      color={"error"}
      className="!flex !gap-2 !items-center"
      onClick={empLogout}
    >
      <IoIosLogOut /> Logout
    </ButtonCompo>,
  ];

  //all role-based page navigation
  const roleBasedNav = {
    onBoardingAccess: {
      header: "Onboarding Employees",
      link: "/admin/onboarding",
      icon: <LuUsers />,
    },
    leaveApproval: {
      header: "Leave Approval",
      link: "/admin/leave/applications/all",
      icon: <FaRegCalendarCheck />,
    },
    employeeRecordAccess: {
      header: "Employee Record Access",
      link: "/superadmin/dashboard",
      icon: <RxDashboard />,
    },
    employeeEditBoarding: {
      header: "Employee Edit Boarding",
      link: "/admin/onboarded-employees",
      icon: <LiaUserEditSolid />,
    },
    employeeManagement: {
      header: "Employee Management",
      link: "/admin/employee/management",
      icon: <RiUserSettingsLine />,
    },
    projectAssign: {
      header: "Project Management",
      link: "/admin/project/management",
      icon: <RiUserSettingsLine />,
    },
    salaryStructureCreation: {
      header: "Salary Configurations",
      link: "/admin/salary-structure",
      icon: <IoWalletOutline />,
    },
    payslipEditGenerate: {
      header: "Payslip Management",
      link: "/admin/payslip/management",
      icon: <IoDocumentsOutline />,
    },
    leaveManagement: {
      header: "Leave Management",
      link: "/admin/leave",
      icon: <FaRegCalendarTimes />,
    },
    notificationSend: {
      header: "Notification Send",
      link: "/admin/notification/management",
      icon: <IoMdNotificationsOutline />,
    },
    eventManagement: {
      header: "Event Management",
      link: "/superadmin/dashboard",
      icon: <RxDashboard />,
    },
    equipmentManagement: {
      header: "Equippment Management",
      link: "/superadmin/dashboard",
      icon: <RxDashboard />,
    },
    employeeDetailsView: {
      header: "Employee Details",
      link: "/superadmin/dashboard",
      icon: <RxDashboard />,
    },
    housekeepingStaffManagement: {
      header: "Housekeeping Stuff Management",
      link: "/superadmin/dashboard",
      icon: <RxDashboard />,
    },
    goalManagement: {
      header: "Goal Management",
      link: "/admin/company/goal/management",
      icon: <GoGoal />,
    },
    policyManagement: {
      header: "Policy Management",
      link: "/admin/company/policy/management",
      icon: <IoDocumentTextOutline />,
    },
    letterGenerate: {
      header: "Letter Generate",
      link: "/admin/letter/generate",
      icon: <BsFiletypeDoc />,
    },
    companyManagement: {
      header: "Company Settings",
      link: "/admin/company/settings",
      icon: <IoSettingsOutline />,
    },
    talentAquisation: {
      header: "Talent Aquisation",
      link: "/admin/talent/aquisation",
      icon: <IoPersonAddOutline />,
    },
    hiringReq: {
      header: "Hiring Request",
      link: "/admin/hiring/options",
      icon: <IoPersonAddOutline />,
    },
  };

  //fetch all notifications
  async function getNotifications() {
    try {
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/notifications`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      let rawData = res.data?.data;
      let totalUnopenedNotification = 0;
      rawData?.map((e) => {
        if (e?.isOpen === false) {
          totalUnopenedNotification = totalUnopenedNotification + 1;
        }
      });
      setUnopenedNotofications(totalUnopenedNotification);
    } catch (error) {
      console.log(error);
    } finally {
    }
  }

  useEffect(() => {
    getNotifications();
  }, [reduxReload]);

  //nav array initialization
  let adminNav = [];

  //check flag from employeeData and push nav object based on the flag
  if (
    employeeData?.admin !== undefined &&
    employeeData?.adminId !== undefined &&
    employeeData?.adminId?.length > 0
  ) {
    Object.keys(roleBasedNav)?.filter((e) => {
      if (employeeData?.admin[e] === true) {
        adminNav.push(roleBasedNav[e]);
      }
    });
    if (haveTeamMembers || employeeData?.adminRole === "manager") {
      const teamMembers = {
        header: "Team Members",
        link: "/admin/team",
        icon: <LuUsers />,
      };
      const allAttendance = {
        header: "Teams Attendance",
        link: "/admin/all/attendance",
        icon: <IoMdTime />,
      };
      const compOffRecords = {
        header: "Comp OFF Records",
        link: "/admin/comp-off/records/all",
        icon: <FaRegCalendarPlus />,
      };
      const managerProjects = {
        header: "Projects",
        link: "/admin/project/management/manager",
        icon: <IoMdTime />,
      };
      adminNav.push(teamMembers);
      adminNav.push(allAttendance);
      adminNav.push(compOffRecords);
      adminNav.push(managerProjects);
    }
    // check role and add ticket management page
    if (
      employeeData?.admin?.role === "headHr" ||
      employeeData?.admin?.role === "facilityTeam" ||
      employeeData?.admin?.role === "itHelpDesk"
    ) {
      const ticketManage = {
        header: "Ticket Management",
        link: "/admin/ticket/management",
        icon: <BsTicketPerforated />,
      };
      adminNav.push(ticketManage);
    }
    // if (employeeData?.adminRole === "manager") {
    //   const teamMembers = {
    //     header: "Team Members",
    //     link: "/admin/team",
    //     icon: <LuUsers />,
    //   };
    //   const allAttendance = {
    //     header: "Teams Attendance",
    //     link: "/admin/all/attendance",
    //     icon: <IoMdTime />,
    //   };
    //   const compOffRecords = {
    //     header: "Comp OFF Records",
    //     link: "/admin/comp-off/records/all",
    //     icon: <FaRegCalendarPlus />,
    //   };
    //   adminNav.push(teamMembers);
    //   adminNav.push(allAttendance);
    //   adminNav.push(compOffRecords);
    // }
  }

  useEffect(() => {
    if (Array.isArray(adminNav) && adminNav.length > 0) {
      dispatch(setAdminRoleData({roles: adminNav}))
    }
  },[employeeData])

  if (!isEmployee && !isSuperadmin) {
    return <div></div>;
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <header className="flex header_bg justify-between items-center px-3 md:px-5 py-3 border-b-[0px]">
        <div className="flex items-center gap-3">
          <button onClick={() => setNavOpen((prev) => !prev)}>
            <RiMenu2Fill size={"22px"} className="text-slate-700" />
          </button>
          <Link
            to={
              isSuperadmin === true
                ? "/superadmin/dashboard"
                : "/employee/dashboard"
            }
          >
            <img src={logo} className="w-[8rem]" alt="" />
          </Link>
        </div>
        {isEmployee && (
          <div className="flex items-center gap-5">
            <Link to={"/notifications"}>
              <Badge badgeContent={unopenedNotifications} color="error">
                <IoMdNotificationsOutline size="30px" className="text-white" />
              </Badge>
            </Link>
            <PopOverBox
              trigger={
                <section className="w-[2.5rem] h-[2.5rem]">
                  <img
                    src={`${SERVER_URL}/api/v1/file/view/${employeeData?.logo}`}
                    className="w-full h-full object-cover rounded-full"
                    alt=""
                  />
                </section>
              }
              dataArray={popOverData}
            ></PopOverBox>
          </div>
        )}
        <div
          className={`w-full fixed left-0 top-0  h-[100vh] z-[100] bg-slate-950/30 transition-all ${
            navOpen === true ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={() => setNavOpen(false)}
        >
          <div
            className={`w-[17rem] bg-blue-500 h-full shadow-lg flex flex-col overflow-auto px-2 py-3 gap-2 transition-transform duration-150 ease-in-out transform ${
              navOpen === true ? "translate-x-0" : "-translate-x-full"
            }`}
            style={{ scrollbarWidth: "none" }}
          >
            <div className="w-full flex justify-center items-center mb-7 mt-3 bg-white py-5 rounded-2xl shadow-lg">
              <img src={logo} className="w-[8rem]" alt="" />
            </div>
            {isEmployee &&
              employeeNavData?.map((e, i) => (
                <Link
                  to={e?.link}
                  className="px-3 py-3 text-white font-medium hover:bg-slate-100/20 rounded-[10px] flex items-center gap-3"
                  key={i}
                >
                  <section className="text-[18px]">{e?.icon}</section>
                  {e?.header}
                </Link>
              ))}
            {adminNav?.length > 0 ? (
              <p className="px-3 font-bold text-[15px] uppercase text-white">
                {employeeData?.admin?.role === "headHr"
                  ? "Human Resource"
                  : employeeData?.admin?.role === "hrRecruiter"
                  ? "Recruiter"
                  : employeeData?.admin?.role === "manager"
                  ? "Manager"
                  : employeeData?.admin?.role === "facilityTeam"
                  ? "Facility"
                  : employeeData?.admin?.role === "itHelpDesk"
                  ? "IT Helpdesk"
                  : "Custom"}{" "}
                Task
              </p>
            ) : (
              ""
            )}
            {isEmployee && employeeData?.adminId && (
              <section className="px-2 py-3 bg-blue-50/10 rounded-2xl">
                {isEmployee &&
                  adminNav?.map((e, i) => (
                    <Link
                      to={e?.link}
                      className="px-3 py-3 text-white hover:bg-slate-100/10 rounded-[10px] flex items-center font-medium gap-3"
                      key={i}
                    >
                      <section className="text-[22px]">{e?.icon}</section>
                      {e?.header}
                    </Link>
                  ))}
              </section>
            )}
            {isSuperadmin && (
              <section className="px-2 py-3 bg-blue-50/10 rounded-2xl">
                {isSuperadmin &&
                  superadminNavData?.map((e, i) => (
                    <Link
                      to={e?.link}
                      className="px-3 py-3 text-white hover:bg-slate-100/20 rounded-[10px] flex items-center gap-3"
                      key={i}
                    >
                      {e?.icon}
                      {e?.header}
                    </Link>
                  ))}
              </section>
            )}
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
